"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZuoraVerifyPaymentMethodSchema = void 0;
exports.ZuoraVerifyPaymentMethodSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        paymentMethodId: {
            type: 'string',
            minLength: 1,
        },
    },
    required: [
        'paymentMethodId',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoienVvcmEtdmVyaWZ5LXBheW1lbnQtbWV0aG9kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2RvbXMvc2NoZW1hcy96dW9yYS96dW9yYS12ZXJpZnktcGF5bWVudC1tZXRob2QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxPQUFPLEVBQUUseUNBQXlDO0lBQ2xELFVBQVUsRUFBRTtRQUNWLGVBQWUsRUFBRTtZQUNmLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtLQUNGO0lBQ0QsUUFBUSxFQUFFO1FBQ1IsaUJBQWlCO0tBQ2xCO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFp1b3JhVmVyaWZ5UGF5bWVudE1ldGhvZFNjaGVtYSA9IHtcbiAgJHNjaGVtYTogJ2h0dHA6Ly9qc29uLXNjaGVtYS5vcmcvZHJhZnQtMDcvc2NoZW1hIycsXG4gIHByb3BlcnRpZXM6IHtcbiAgICBwYXltZW50TWV0aG9kSWQ6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgbWluTGVuZ3RoOiAxLFxuICAgIH0sXG4gIH0sXG4gIHJlcXVpcmVkOiBbXG4gICAgJ3BheW1lbnRNZXRob2RJZCcsXG4gIF0sXG4gIHR5cGU6ICdvYmplY3QnLFxufVxuIl19